import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import { useI18n } from '../contexts/I18nContext';

export const NotFoundPage: React.FC = () => {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center">
        <div className="space-y-4">
          <h1 className="text-9xl font-bold text-gray-300">404</h1>
          <h2 className="text-2xl font-bold text-gray-900">{t('notFound.title')}</h2>
          <p className="text-gray-600">{t('notFound.subtitle')}</p>
          <div className="mt-6">
            <Link to="/dashboard" className="btn-primary inline-flex items-center">
              <Home className="h-4 w-4 mr-2" />
              {t('notFound.goHome')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
